import { Box, Chip, Typography } from "@mui/material";
import Reveal from "../motion/Reveal";
import { gradients } from "../../theme/theme";

/** Eyebrow chip + gradient title + optional subtitle, reveal-animated. */
export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "center",
  maxWidth = 720,
}) {
  return (
    <Reveal
      sx={{
        textAlign: align,
        mx: align === "center" ? "auto" : 0,
        maxWidth,
        mb: { xs: 4, md: 6 },
      }}
    >
      {eyebrow && (
        <Chip
          label={eyebrow}
          size="small"
          sx={{
            mb: 2,
            px: 0.5,
            fontWeight: 700,
            letterSpacing: "0.08em",
            color: "primary.main",
            bgcolor: (t) =>
              t.palette.mode === "dark" ? "rgba(79,124,255,0.14)" : "rgba(79,124,255,0.1)",
            border: "1px solid",
            borderColor: "rgba(79,124,255,0.3)",
          }}
        />
      )}
      <Typography variant="h3" sx={{ fontSize: { xs: "1.9rem", md: "2.6rem" }, mb: subtitle ? 1.5 : 0 }}>
        {title}
        {/* a thin gradient underline accent */}
        <Box
          component="span"
          sx={{
            display: "block",
            width: 64,
            height: 4,
            mt: 1.5,
            borderRadius: 2,
            mx: align === "center" ? "auto" : 0,
            background: gradients.brand,
          }}
        />
      </Typography>
      {subtitle && (
        <Typography color="text.secondary" sx={{ fontSize: { xs: "1rem", md: "1.1rem" } }}>
          {subtitle}
        </Typography>
      )}
    </Reveal>
  );
}
